interface ITrendingState {
  tags: any;
  loading: boolean;
  error: Error | null;
}

interface ICreatorsState {
  creators: any;
  loading: boolean;
  error: Error | null;
}

interface INichesState {
  niches: any;
  loading: boolean;
  error: Error | null;
}

interface ITagsState {
  tags: any;
  loading: boolean;
  error: Error | null;
}

interface IHistoryState {
  history: any;
  loading: boolean;
  error: Error | null;
}

export interface ISearchState {
  trendingTags: ITrendingState;
  creators: ICreatorsState;
  niches: INichesState;
  tags: ITagsState;
  history: IHistoryState;
}

const defaultState = {
  trendingTags: {
    tags: [],
    loading: false,
    error: null
  },
  creators: {
    creators: [],
    loading: false,
    error: null
  },
  niches: {
    niches: [],
    loading: false,
    error: null
  },
  tags: {
    tags: [],
    loading: false,
    error: null
  },
  history: {
    history: [],
    loading: false,
    error: null
  }
};

export const getDefaultSearchState = () => defaultState;
